///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="../../../components/fileUpload/fileUpload.service.ts"/>
module Meevo.Plugins.DocsAndForms {
    'use strict';

    import CommonSectionBase = Meevo.Components.CommonClasses.CommonSectionBase;
    import MeevoFileUploadService = Meevo.Components.FileUpload.MeevoFileUploadService;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export enum BuilderEnum {
        None,
        Custom,
        Designer,
        Templates,
    }

    export class FormBuilderSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<DocsAndFormsModel> {

        public selectedTab: number;
        public selectedBuilder: BuilderEnum;
        public disableCrud: boolean = true;

        public formBuilderModel: IFormBuilderModel;

        get model() {
            return this._model;
        }

        set model(model: IDocsAndFormsModel) {
            if (!model) {
                this._model = null;
                return;
            }

            model.objectStateEnum = model.objectState;
            this.formBuilderModel.logoSrc = model.meevoFile ? MeevoFileUploadService.getImageUrl(model.meevoFile) : null;
            this.selectedTab = model.formCreationTypeEnum === Meevo.Plugins.DocsAndForms.DocsAndFormsCreationTypeEnum.CustomHtmlUpload
                ? 1
                : 0;
            this._model = new DocsAndFormsModel(model);
        }

        get builderEnum(): typeof BuilderEnum {
            return BuilderEnum;
        }

        protected _model: DocsAndFormsModel;

        constructor(sectionId: number,
                    displayNameContentKey: string,
                    template: string,
                    isPrimarySection: boolean,
                    handlesOwnCrud: boolean,
                    baseEndpoint: string,
                    sectionEndpoint: string,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    noun: Meevo.Model.NounEnum,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    sectionSecurityKey: string,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $translate: ng.translate.ITranslateService,
                    protected $scope: ng.IScope) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.selectedTab = 0;
            this.selectedBuilder = BuilderEnum.None;
            this.formBuilderModel = new FormBuilderModel();
            this.disableCrud = true;
        }

        preSave() {
            // Validation handled by backend FormValidator.
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.takeBackup();
        }

        selectBuilder(builder: BuilderEnum) {
            this.selectedBuilder = builder;

            const clearModel = [
                BuilderEnum.Designer,
                BuilderEnum.Templates,
            ].indexOf(builder) !== -1;

            if (clearModel) {
                this.model = null;
            }
        }

        closeBuilder() {
            if (this.mode === MaintenanceFormState.Editing) {
                this.modalService.alert('MESSAGE_PENDING_CHANGES');

                return;
            }

            this.$scope.$broadcast(Meevo.Components.Common.Messages.CLOSE_FORM_DESIGNER);
        }
    }
}
